import React, {Component} from 'react'
import {Form, Input, Button} from 'antd'
import { UserOutlined, LockOutlined } from '@ant-design/icons'
import {inject, observer} from 'mobx-react'
import './index.css'
import auth from '../../utils/auth'

const storage = window.localStorage

@inject('accountStore')
@observer
class Login extends Component {
  constructor(props) {
    super(props)
    this.onSubmit = this.onSubmit.bind(this)
  }

  onSubmit(fields) {
    const {accountStore} = this.props
    let params = {
      'username': fields.username,
      'password': fields.password
    }
    accountStore.onLoginByPwd(params)
  }

  componentDidMount() {
    const {accountStore} = this.props
    auth.captureHarnessRedirect()
    accountStore.onGetThemeStyle()
  }

  render() {
    const themeStyle = JSON.parse(storage.getItem('themeStyle'))
    const loginBackground = themeStyle?.loginBackground || require('../../assets/images/login-bg2.png')
    const backgroundStyle = {
      backgroundImage: `url(${loginBackground})`,
      backgroundPosition: '50%',
      backgroundColor: 'rgba(0, 61, 175, 1)',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover'
    }
    const loginMainStyle = {
      height: '325px',
      top: '50%',
      right: '10%',
      marginTop: '-175px',
      background: 'hsla(0, 0%, 100%, .25)',
      padding: '22px 16px 16px',
      boxShadow: 'inset 0 0 8px 0 hsla(0, 0%, 100%, .25)',
      border: 'none',
      zIndex: 2,
    }
    const loginMainStyleIsColumn = {
      height: '350px',
      left: '50%',
      top: '50%',
      padding: '22px 16px 16px 16px',
      margin: '0 auto',
      border: '1px solid #FFF',
      transform: 'translate3d(-50%, -50%, 0)',
    }
    const emailBtn = {
      background: '#fd680b',
      bottom: '55px',
      fontSize: '20px',
      fontFamily: 'Roboto, sans-serif',
    }
    return (
      <div className="login-background" style={backgroundStyle}>
        <div className="login-main" style={themeStyle?.loginIsColumn ? loginMainStyle : loginMainStyleIsColumn}>
          {/*<div className="login-main-background"/>*/}
          {!themeStyle?.loginIsColumn && <div className="login-main-top">
            <div className="login-main-top-image">
              <img alt="" src={themeStyle?.loginLogoImage || require('../../assets/images/logo3.png')}/>
            </div>
            <div className="login-main-top-title">{themeStyle?.loginTitle || '数字工博'}</div>
          </div>}
          
          <div className="login-main-from">
            <div className="login-main-from-email" style={themeStyle?.loginIsColumn ? {paddingTop: '34px'} : null}>
              <Form
                onFinish={this.onSubmit}
                layout="vertical"
              >
                <Form.Item
                  // label='User Name'
                  style={{
                    width: '100%',
                    borderRadius: '8px',
                    height: '50px',
                    marginBottom: themeStyle?.loginIsColumn ? '32px' : '16px'
                  }} name="username" rules={[{required: true, message: '请输入用户名'}]}>
                  <Input placeholder={ themeStyle?.loginIsColumn ? "用户名" : "请输入用户名"} className="email"
                    prefix={ themeStyle?.loginIsColumn ? <UserOutlined style={{fontSize: 24, color: '#A4A4A2'}}/> : null}
                    suffix={ themeStyle?.loginIsColumn ? null : <img alt="" width={24} src={require('../../assets/images/login-username-icon.png')}/>}/>
                </Form.Item>
                <Form.Item
                  // label='Password'
                  style={{
                    width: '100%',
                    borderRadius: '8px',
                    height: '50px',
                  }} name="password" rules={[{required: true, message: '请输入密码'}]}>
                  <Input.Password placeholder={themeStyle?.loginIsColumn ? "密码" : "请输入密码"} className="email"
                    prefix={themeStyle?.loginIsColumn ? <LockOutlined style={{fontSize: 24, color: '#A4A4A2'}}/> : null} 
                    iconRender={() => themeStyle?.loginIsColumn ? null : <img alt="" width={24} src={require('../../assets/images/login-password-icon.png')}/>}/>

                </Form.Item>
                <Button htmlType="submit" className="email-btn" style={themeStyle?.loginIsColumn ? emailBtn : null}>登录</Button>
              </Form>
            </div>
          </div>
        </div>
        
        {themeStyle?.loginIsColumn && <div className="login-slogan">
          <div className="main-content">
            <img src={themeStyle?.loginLogoImage || require('../../assets/images/logo3.png')} alt="logo"/>
            <span>{themeStyle?.loginTitle || '数字工博'}</span>
          </div>
          {themeStyle?.loginSubTitle && <>{themeStyle?.loginSubTitle || ''}</>}
        </div>}
        <iframe style={{visibility: 'hidden'}} id="sso" title="sso"/>
        <iframe style={{visibility: 'hidden'}} id="ssofed" title="ssofed"/>
      </div>
      // <Result
      //   status="success"
      //   title={<FormattedMessage id="Logout Success"/>}
      //   // subTitle={<FormattedMessage id='Please add permission first.'/>}
      //   // extra={this.backToHomeButton}
      // />
    )
  }
}

export default Login
